module.exports = __webpack_public_path__ + "img/swords.49a9ec75.png";